import { NavLink } from "react-router-dom";
import { NAV_ITEMS } from "./navItems";

export const BottomNav = () => (
  <nav className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-[#0A0B10]/90 backdrop-blur-xl border-t border-white/10 pb-[env(safe-area-inset-bottom)]">
    <ul className="flex justify-around items-end px-2 pt-2 pb-2">
      {NAV_ITEMS.map(({ to, label, icon: Icon, testId, end, accent }) => (
        <li key={to}>
          <NavLink to={to} end={end} data-testid={`${testId}-mobile`}
            className={({ isActive }) => `flex flex-col items-center gap-1 px-3 py-1 text-[10px] font-semibold uppercase tracking-wider transition-colors duration-200 ${isActive ? "text-white" : "text-slate-500 hover:text-slate-300"}`}>
            {({ isActive }) => (
              <>
                {accent ? (
                  <span className={`-mt-6 grid h-12 w-12 place-items-center rounded-full bg-nw-red shadow-[0_0_20px_rgba(255,30,39,0.55)] ring-2 ring-slate-300/40 transition-transform duration-200 ${isActive ? "scale-110" : ""}`}>
                    <Icon className="h-6 w-6 text-white" />
                  </span>
                ) : (
                  <Icon className={`h-5 w-5 transition-transform duration-200 ${isActive ? "text-nw-red scale-110" : ""}`} />
                )}
                <span>{label}</span>
              </>
            )}
          </NavLink>
        </li>
      ))}
    </ul>
  </nav>
);
